module.exports = __webpack_public_path__ + "static/media/dashedBorder.5d890af1.svg";